<div class="animated fadeIn px-30" >

  <div class="form-group">

    <button type="button" class="btn btn-sm btn-hero btn-alt-primary" (click)="msalLogin()">
      <i class="si si-login mr-10"></i> Sign In
    </button>

  </div>
  
</div>
<!-- END Sign In Form -->



// WEBPACK FOOTER //
// ./client/app/features/login/login.component.html